var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.3333L6.19065 15.0717C5.77572 14.553 5.56826 14.2937 5.54554 13.9844C5.52282 13.6751 5.69016 13.3883 6.02483 12.8145L8.84235 7.98452C9.40743 7.01579 9.68998 6.53143 10.1526 6.26572C10.6152 6 11.176 6 12.2975 6H19.7025C20.824 6 21.3847 6 21.8474 6.26572C22.31 6.53143 22.5925 7.01579 23.1576 7.98452L25.9751 12.8145C26.3098 13.3883 26.4771 13.6751 26.4544 13.9844C26.4317 14.2937 26.2242 14.553 25.8093 15.0717L16 27.3333ZM16 27.3333L20.6666 12.6667M16 27.3333L11.3333 12.6667M26 14L20.6666 12.6667M20.6666 12.6667L18 6M20.6666 12.6667H11.3333M14 6L11.3333 12.6667M11.3333 12.6667L5.99998 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamant);
export default __webpack_public_path__ + "static/media/diamant.36cae02ceef1cb41800bbdc8abcc8cee.svg";
export { ForwardRef as ReactComponent };